
import styles from './PeopleSkeleton.module.css';

/** A single placeholder row matching PersonListItem's layout (avatar + two
 *  text lines, plus an optional tag line for the admin list). */
const PersonListItemSkeleton = ({ showTags = false }: { showTags?: boolean }) => (
    <div className={styles.item} aria-hidden="true">
        <div className={styles.avatar} />
        <div className={styles.info}>
            <div className={`${styles.line} ${styles.nameLine}`} />
            <div className={`${styles.line} ${styles.metaLine}`} />
            {showTags && <div className={`${styles.line} ${styles.tagLine}`} />}
        </div>
    </div>
);

/** A list of placeholder rows shown while the people query is loading. */
const PeopleListSkeleton = ({
    count = 8,
    showTags = false,
}: {
    count?: number;
    showTags?: boolean;
}) => (
    <div>
        {Array.from({ length: count }).map((_, i) => (
            <PersonListItemSkeleton key={i} showTags={showTags} />
        ))}
    </div>
);

/** Placeholder bar matching the search input's height, shown during the
 *  initial load before we know whether the real search bar should appear. */
const SearchSkeleton = () => <div className={styles.searchSkeleton} aria-hidden="true" />;

export { PersonListItemSkeleton, PeopleListSkeleton, SearchSkeleton };
